<template>
  <div id="dropdown-menu" class="dropdown-menu" :class="{ 'dropdown-menu': true, 'show-menu': isOpenDropdown === true, 'close-menu': isOpenDropdown === false }">
      <div id="header-dropdown" class="header-dropdown">
        <div @click="closeDropdown" class="menu-button" id="header-dropdown-close">
            <div id="line1" class="line" :class="{'animate-1': isOpenDropdown || showIcon }"></div>
            <div id="line2" class="line" :class="{'animate-2': isOpenDropdown || showIcon }"></div>
        </div>
        <span class="session-btn" @click="closeDropdown" :class="{ disabled_user: $route.name === 'product-detail' || $route.name === 'modal'}">
          <UserButton :dropdownMenu="true" />
        </span>
      </div>
      <div class="options">
        <a href="https://www.goiko.com">
          <svg class="logo-rotate" :class="{'animate-logo-rotate': isOpenDropdown}" id="logo-dropdown"  viewBox="0 0 64 24">
              <path d="M8.49383 8.17552H10.328C10.8078 8.17552 11.1746 7.78753 11.1746 7.34411V5.903C11.1746 4.01848 10.6949 2.54965 9.76367 1.52425C8.83245 0.526559 7.44974 0 5.5873 0C3.72487 0 2.37037 0.526559 1.41093 1.52425C0.479718 2.54965 0 3.99076 0 5.903V18.097C0 19.9815 0.479718 21.4503 1.41093 22.4757C2.34215 23.5012 3.75309 24 5.5873 24C7.42152 24 8.83245 23.5012 9.76367 22.4757C10.6949 21.4503 11.1746 20.0092 11.1746 18.097V11.5012C11.1746 11.03 10.7795 10.6697 10.328 10.6697H6.80071C6.32099 10.6697 5.95415 11.0577 5.95415 11.5012V13.164C5.95415 13.6351 6.34921 13.9954 6.80071 13.9954C7.28042 13.9954 7.64727 14.3834 7.64727 14.8268V18.3187C7.64727 19.1778 7.47795 19.7598 7.11111 20.0924C6.77249 20.4249 6.29277 20.5912 5.70018 20.5912C5.10758 20.5912 4.62787 20.4249 4.28924 20.0924C3.95062 19.7598 3.75309 19.1778 3.75309 18.3187V5.68129C3.75309 4.82217 3.9224 4.24018 4.28924 3.87991C4.62787 3.54734 5.10758 3.35335 5.70018 3.35335C6.29277 3.35335 6.77249 3.51963 7.11111 3.87991C7.47795 4.21247 7.64727 4.82217 7.64727 5.65358V7.3164C7.64727 7.81524 8.01411 8.17552 8.49383 8.17552Z"></path>
              <path d="M16.1412 1.52425C15.1535 2.54965 14.6738 3.99076 14.6738 5.903V18.097C14.6738 19.9815 15.1535 21.4503 16.1412 22.4757C17.1289 23.5012 18.5398 24 20.374 24C22.2082 24 23.6192 23.5012 24.6068 22.4757C25.5945 21.4503 26.0742 20.0092 26.0742 18.097V5.903C26.0742 4.01848 25.5945 2.54965 24.6068 1.52425C23.6192 0.498846 22.2082 0 20.374 0C18.5116 0 17.1006 0.526559 16.1412 1.52425ZM22.2929 5.65358V18.3187C22.2929 19.1778 22.1236 19.7598 21.7567 20.1201C21.4181 20.4527 20.9384 20.6467 20.3458 20.6467C19.7532 20.6467 19.2735 20.4804 18.9349 20.1201C18.5962 19.7875 18.3987 19.1778 18.3987 18.3187V5.65358C18.3987 4.79446 18.568 4.21247 18.9349 3.85219C19.2735 3.51963 19.7532 3.32563 20.3458 3.32563C20.9384 3.32563 21.4181 3.49192 21.7567 3.85219C22.1236 4.21247 22.2929 4.82217 22.2929 5.65358Z"></path>
              <path d="M30.702 0.2771C30.2223 0.2771 29.8555 0.665091 29.8555 1.10851V22.8637C29.8555 23.3348 30.2505 23.6951 30.702 23.6951H32.7338C33.2135 23.6951 33.5803 23.3071 33.5803 22.8637V1.10851C33.5803 0.637377 33.1853 0.2771 32.7338 0.2771H30.702Z"></path>
              <path d="M40.5775 0.2771H38.5458C38.0661 0.2771 37.6992 0.665091 37.6992 1.10851V22.8637C37.6992 23.3348 38.0943 23.6951 38.5458 23.6951H40.5775C41.0572 23.6951 41.4241 23.3071 41.4241 22.8637V16.7113C41.4241 16.5727 41.4523 16.4341 41.537 16.3233L41.7063 15.9907C42.0449 15.3533 43.0043 15.4087 43.2583 16.0739L46.0237 23.1686C46.1366 23.5011 46.4752 23.6951 46.8139 23.6951H48.8174C49.41 23.6951 49.8333 23.1131 49.6075 22.5589L44.9796 11.0577C44.895 10.836 44.895 10.5866 45.0079 10.3926L49.4664 1.4965C49.7486 0.942227 49.3253 0.2771 48.7045 0.2771H46.8703C46.5317 0.2771 46.2495 0.471095 46.1084 0.748231L41.5087 10.4203H41.4523V1.10851C41.4241 0.637377 41.0572 0.2771 40.5775 0.2771Z"></path>
              <path d="M54.067 1.52425C53.1075 2.54965 52.5996 3.99076 52.5996 5.903V18.097C52.5996 19.9815 53.0793 21.4503 54.067 22.4757C55.0546 23.5012 56.4656 24 58.2998 24C60.134 24 61.5449 23.5012 62.5326 22.4757C63.5202 21.4503 64 20.0092 64 18.097V5.903C64 4.01848 63.5202 2.54965 62.5326 1.52425C61.5449 0.498846 60.134 0 58.2998 0C56.4656 0 55.0546 0.526559 54.067 1.52425ZM60.2469 5.65358V18.3187C60.2469 19.1778 60.0776 19.7598 59.7107 20.1201C59.3721 20.4527 58.8924 20.6467 58.2998 20.6467C57.7072 20.6467 57.2275 20.4804 56.8889 20.1201C56.5502 19.7875 56.3527 19.1778 56.3527 18.3187V5.65358C56.3527 4.79446 56.522 4.21247 56.8889 3.85219C57.2275 3.51963 57.7072 3.32563 58.2998 3.32563C58.8924 3.32563 59.3721 3.49192 59.7107 3.85219C60.0776 4.21247 60.2469 4.82217 60.2469 5.65358Z"></path>
          </svg>
        </a>
        <div class="section" :class="{'animate-primary-menu': isOpenDropdown}" id="primary-menu">
          <div class="options__main nav-header-primary">
            <a href="https://www.goiko.com/es/carta/"><span class="options__main--title">CARTA</span></a>
            <span @click="closeDropdown('modal')" class="options__main--title">HACER PEDIDO</span>
            <a href="https://www.goiko.com/es/nuestros-restaurantes/"><span class="options__main--title">RESTAURANTES</span></a>
          </div>
          <div class="section__body">
            <div class="options__footer">
              <div class="options__footer--1 nav-header-secondary">
                <a href="https://www.goikofriends.com/">
                  <div class="text-container">
                    <span class="hover-text">FRIENDS WITH BENEFITS</span>
                  </div>
                </a>
                <a href="https://www.goiko.com/es/foodtruck/">
                  <div class="text-container">
                    <span class="hover-text">FOODTRUCKS</span>
                  </div>
                </a>
                <a href="https://www.goiko.com/es/unete-al-equipo/">
                  <div class="text-container">
                    <span class="hover-text">ÚNETE AL EQUIPO</span>
                  </div>
                </a>
                <a href="https://www.goiko.com/es/goikocina/">
                  <div class="text-container">
                    <span class="hover-text">GOIKOCINA</span>
                  </div>
                </a>
              </div>
            </div>
            <div class="header__footer">
              <div class="social-media-container" :class="{'animate-social-network': isOpenDropdown}" id='social-network-container'>
                <a href="https://www.facebook.com/goiko" class="social__link">
                  <svg class="icon--filled" viewBox="0 0 18 18">
                    <path class="icon--filled__glyph" d="M18 9C18 4.02943 13.9706 0 9 0C4.02943 0 0 4.02943 0 9C0 13.4921 3.29115 17.2155 7.59375 17.8907V11.6016H5.30859V9H7.59375V7.01719C7.59375 4.76156 8.93742 3.51562 10.9932 3.51562C11.9776 3.51562 13.0078 3.69141 13.0078 3.69141V5.90625H11.873C10.755 5.90625 10.4062 6.60006 10.4062 7.3125V9H12.9023L12.5033 11.6016H10.4062V17.8907C14.7088 17.2155 18 13.4921 18 9Z"></path>
                  </svg>
                </a>
                <a href="https://twitter.com/goiko" class="social__link">
                  <svg class="icon--filled" viewBox="0 0 24 20">
                    <path class="icon--filled__glyph" d="M23.9528 2.56987C23.0545 2.96475 22.1031 3.22553 21.129 3.34387C22.1558 2.72759 22.9245 1.76013 23.2928 0.62062C22.3216 1.18387 21.2645 1.58394 20.1638 1.80487C19.4236 1.01396 18.443 0.489463 17.3743 0.312743C16.3055 0.136024 15.2083 0.316965 14.2529 0.827495C13.2975 1.33803 12.5373 2.1496 12.0902 3.13631C11.6431 4.12301 11.5342 5.22968 11.7803 6.28462C7.69053 6.09337 4.06504 4.12837 1.64029 1.15987C1.19889 1.91053 0.968041 2.76631 0.972035 3.63712C0.971434 4.44664 1.17074 5.24379 1.55227 5.95777C1.93379 6.67175 2.48571 7.28047 3.15903 7.72987C2.37875 7.70628 1.61547 7.49617 0.933035 7.11712V7.17637C0.932797 8.31264 1.32544 9.41404 2.04443 10.2939C2.76341 11.1738 3.7645 11.778 4.87804 12.0041C4.45623 12.1168 4.02163 12.1745 3.58504 12.1759C3.26929 12.1759 2.96779 12.1451 2.66704 12.0896C2.98393 13.0674 3.59779 13.9221 4.42317 14.5347C5.24854 15.1472 6.24437 15.4873 7.27204 15.5074C5.53084 16.871 3.38238 17.6107 1.17079 17.6081C0.779065 17.6097 0.387606 17.5876 -0.00146484 17.5421C2.2546 18.9877 4.87831 19.7551 7.55779 19.7531C16.608 19.7531 21.5535 12.2569 21.5535 5.76487C21.5535 5.55787 21.5535 5.34712 21.5378 5.13562C22.5052 4.44228 23.3389 3.57933 23.9985 2.58862L23.9528 2.56987Z"></path>
                  </svg>
                </a>
                <a href="https://www.instagram.com/goiko/" class="social__link">
                  <svg class="icon--filled" viewBox="0 0 24 24">
                    <path class="icon--filled__glyph" d="M12.0005 0C8.7387 0 8.3322 0.01575 7.0557 0.06975C5.77395 0.13275 4.90695 0.3315 4.14195 0.6285C3.3413 0.930765 2.6162 1.40401 2.0172 2.01525C1.40426 2.61285 0.930751 3.33835 0.630453 4.14C0.333453 4.905 0.134703 5.772 0.0717031 7.05375C0.0139531 8.331 0.00195312 8.73675 0.00195312 11.9985C0.00195312 15.2603 0.0177031 15.6667 0.0717031 16.9432C0.134703 18.2213 0.333453 19.092 0.630453 19.857C0.932718 20.6577 1.40596 21.3828 2.0172 21.9818C2.6148 22.5947 3.3403 23.0682 4.14195 23.3685C4.90695 23.6618 5.7777 23.8643 7.0557 23.9272C8.33295 23.985 8.7387 23.997 12.0005 23.997C15.2622 23.997 15.6687 23.9813 16.9452 23.9272C18.2232 23.8643 19.094 23.661 19.859 23.3685C20.6596 23.0662 21.3847 22.593 21.9837 21.9818C22.5974 21.3848 23.0711 20.6591 23.3705 19.857C23.6637 19.092 23.8662 18.2213 23.9292 16.9432C23.987 15.666 23.999 15.2603 23.999 11.9985C23.999 8.73675 23.9832 8.33025 23.9292 7.05375C23.8662 5.77575 23.663 4.9005 23.3705 4.14C23.0682 3.33935 22.5949 2.61425 21.9837 2.01525C21.3868 1.40152 20.6611 0.927885 19.859 0.6285C19.094 0.3315 18.2232 0.13275 16.9452 0.06975C15.668 0.012 15.2622 0 12.0005 0ZM12.0005 2.16C15.2037 2.16 15.5862 2.17575 16.8522 2.22975C18.02 2.2845 18.656 2.4795 19.0782 2.6445C19.6002 2.83719 20.0727 3.14389 20.4612 3.54225C20.8589 3.92912 21.1644 4.40051 21.3552 4.9215C21.5202 5.34375 21.7152 5.97975 21.77 7.1475C21.8239 8.4135 21.8397 8.79675 21.8397 11.9992C21.8397 15.2017 21.824 15.585 21.7655 16.851C21.7025 18.0188 21.5075 18.6548 21.3432 19.077C21.116 19.6403 20.8624 20.034 20.444 20.46C20.0541 20.8559 19.582 21.1611 19.061 21.354C18.644 21.519 17.999 21.714 16.8267 21.7687C15.554 21.8228 15.179 21.8385 11.9675 21.8385C8.75595 21.8385 8.3817 21.8228 7.10745 21.7642C5.9397 21.7013 5.29545 21.5063 4.8732 21.342C4.3032 21.1147 3.91245 20.8612 3.49395 20.4427C3.0717 20.0205 2.8032 19.6185 2.5962 19.0597C2.4282 18.6427 2.2362 17.9977 2.17395 16.8255C2.1312 15.5677 2.11095 15.1778 2.11095 11.9813C2.11095 8.78625 2.1312 8.3955 2.17395 7.122C2.2362 5.94975 2.4282 5.30625 2.5962 4.88775C2.8032 4.317 3.07245 3.927 3.49395 3.50475C3.9117 3.087 4.3032 2.817 4.8732 2.6055C5.29545 2.44125 5.92395 2.24625 7.0962 2.18775C8.36895 2.142 8.74395 2.1255 11.951 2.1255L12.0005 2.16ZM12.0005 5.84025C11.1915 5.83995 10.3903 5.99908 9.64287 6.30853C8.8954 6.61798 8.21624 7.0717 7.64419 7.64374C7.07215 8.21578 6.61843 8.89495 6.30898 9.64242C5.99953 10.3899 5.84041 11.191 5.8407 12C5.84041 12.809 5.99953 13.6101 6.30898 14.3576C6.61843 15.1051 7.07215 15.7842 7.64419 16.3563C8.21624 16.9283 8.8954 17.382 9.64287 17.6915C10.3903 18.0009 11.1915 18.16 12.0005 18.1597C12.8094 18.16 13.6106 18.0009 14.358 17.6915C15.1055 17.382 15.7847 16.9283 16.3567 16.3563C16.9288 15.7842 17.3825 15.1051 17.6919 14.3576C18.0014 13.6101 18.1605 12.809 18.1602 12C18.1605 11.191 18.0014 10.3899 17.6919 9.64242C17.3825 8.89495 16.9288 8.21578 16.3567 7.64374C15.7847 7.0717 15.1055 6.61798 14.358 6.30853C13.6106 5.99908 12.8094 5.83995 12.0005 5.84025ZM12.0005 15.9998C9.78945 15.9998 8.0007 14.211 8.0007 12C8.0007 9.789 9.78945 8.00025 12.0005 8.00025C14.2115 8.00025 16.0002 9.789 16.0002 12C16.0002 14.211 14.2115 15.9998 12.0005 15.9998ZM19.8485 5.59425C19.8481 5.9765 19.6959 6.34296 19.4255 6.6131C19.1551 6.88326 18.7885 7.035 18.4062 7.035C18.2172 7.035 18.03 6.99777 17.8554 6.92544C17.6808 6.85311 17.5221 6.7471 17.3885 6.61345C17.2549 6.47981 17.1488 6.32115 17.0765 6.14653C17.0042 5.97191 16.967 5.78475 16.967 5.59575C16.967 5.40674 17.0042 5.21959 17.0765 5.04497C17.1488 4.87036 17.2549 4.71169 17.3885 4.57805C17.5221 4.4444 17.6808 4.33839 17.8554 4.26606C18.03 4.19373 18.2172 4.1565 18.4062 4.1565C19.199 4.1565 19.8485 4.8015 19.8485 5.59425Z"></path>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/goiko-burgers" class="social__link">
                  <svg class="icon--filled" viewBox="0 0 24 24">
                    <path class="icon--filled__glyph" d="M20.445 20.4533H16.8953V14.883C16.8953 13.5547 16.8675 11.8477 15.039 11.8477C13.188 11.8477 12.906 13.2885 12.906 14.7847V20.4525H9.35175V8.99925H12.7657V10.5615H12.8115C13.2885 9.65925 14.4487 8.7105 16.1798 8.7105C19.7805 8.7105 20.4487 11.0813 20.4487 14.1637V20.4525L20.445 20.4533ZM5.33625 7.434C5.06496 7.4341 4.79631 7.38068 4.54569 7.27679C4.29508 7.1729 4.06742 7.02059 3.87576 6.82858C3.6841 6.63658 3.53221 6.40864 3.42878 6.15784C3.32534 5.90704 3.27241 5.63829 3.273 5.367C3.27344 4.95866 3.39496 4.55963 3.62217 4.22034C3.84939 3.88106 4.1721 3.61677 4.54951 3.46088C4.92692 3.305 5.34208 3.26451 5.74249 3.34456C6.14291 3.4246 6.5106 3.62158 6.79907 3.91058C7.08755 4.19958 7.28385 4.56763 7.36317 4.96818C7.44249 5.36874 7.40126 5.78383 7.24468 6.16095C7.08811 6.53808 6.82323 6.86031 6.48354 7.08691C6.14384 7.31351 5.74459 7.4343 5.33625 7.434ZM7.11675 20.4533H3.555V9H7.11675V20.4533ZM22.227 0H1.77C0.79275 0 0 0.77325 0 1.73025V22.2705C0 23.2275 0.79275 24.0007 1.77 24.0007H22.2233C23.199 24.0007 24 23.2275 24 22.2705V1.73025C24 0.77325 23.199 0 22.2233 0H22.227Z"></path>
                  </svg>
                </a>
              </div>
              <a href="https://www.goiko.com/es/reservas/">
                <div class="wheel-container">
                  <div class="wheel-wrapper">
                    <svg viewBox="0 0 302 302" xmlns="http://www.w3.org/2000/svg">
                      <path class="filled" d="m128.2 42.3c-2.1.6-4.1-1.6-5.1-4.7l-1.4-4.5c-.6-2-1.8-3.3-4.5-2.5l-6.8 2 4.1 13.8-14.9 4.5-11.1-37 25.6-7.7c8.7-2.6 15.4.3 17.2 6.1l.3.9c1.1 3.6-.8 7.7-5.2 10.2 5.7-.9 9.1 1.9 10.3 5.8l1.1 3.6c.7 2.3 1.9 4.2 3.6 5.5l.1.2zm-10.9-22.7c-.7-2.4-2.4-2.9-5.9-1.9l-5 1.5 2.2 7.5 5-1.5c3.5-1 4.6-2.5 3.9-4.8z"></path>
                      <path class="filled" d="m143.5 39 4-38.5 38.2 3.9-1.1 10.7-22.7-2.4-.6 5.4 15 1.6-.6 5.5-15-1.6-.5 5.2 22.7 2.4-1.1 11.8z"></path>
                      <path class="filled" d="m202 54.2c-8.3-4.3-14-10.4-17.4-16.3l8.7-4.7c3.1 5 8.3 10.1 12.8 12.4 4.3 2.2 6.2 1.8 6.9.5 2.3-4.3-22.6-14-16-26.4 3.2-6.2 13.6-7.3 24.2-1.8 8.2 4.3 12.1 9.3 15.6 15.1l-8.8 4c-3.1-4.7-7.3-8.8-11.5-10.9-3.4-1.8-5.5-1.6-6.1-.4-2.5 4.7 22.8 14.4 16.5 26.4-3.7 6.9-14.6 7.5-24.9 2.1z"></path>
                      <path class="filled" d="m223.2 65.1 29.5-25 24.8 29.3-8.2 7-14.8-17.5-4.1 3.5 9.8 11.5-4.3 3.6-9.8-11.5-4 3.4 14.8 17.5-8.9 7.5z"></path>
                      <path class="filled" d="m259.2 126c-.7-2 1.5-4.1 4.6-5.1l4.5-1.4c2-.6 3.3-1.9 2.4-4.6l-2.2-6.7-13.7 4.4-4.8-14.8 36.8-11.9 8.2 25.4c2.8 8.7 0 15.4-5.8 17.3l-.9.3c-3.5 1.1-7.7-.7-10.3-5 1.1 5.7-1.7 9.2-5.6 10.4l-3.6 1.2c-2.3.7-4.2 2-5.4 3.7l-.2.1zm22.5-11.4c2.4-.8 2.9-2.5 1.7-5.9l-1.6-4.9-7.4 2.4 1.6 4.9c1.1 3.5 2.6 4.5 4.9 3.8z"></path>
                      <path class="filled" d="m260.4 168.8 1.4-14.9 40.1-13.4-1.6 16.9-23.7 6.9 21.9 11.6-1.4 14.1z"></path>
                      <path class="filled" d="m246.3 207.8 6.7.9 6.1-12.1-4.6-5.1 6.1-12.1 27.4 31.5-7.5 14.9-41.7-3.3zm26.8 4-7.9-8.5-3.4 6.7z"></path>
                      <path class="filled" d="m214.9 241.8c1.6-1.4 4.4-.2 6.5 2.4l3 3.6c1.3 1.6 3 2.4 5.1.5l5.4-4.5-9.2-11.1 11.9-10 24.8 29.7-20.4 17.1c-7 5.8-14.3 5.8-18.2 1.1l-.6-.7c-2.4-2.8-2.3-7.4.8-11.4-4.9 3.1-9.1 1.8-11.7-1.3l-2.4-2.9c-1.6-1.9-3.4-3.2-5.5-3.6l-.1-.1zm18.9 16.6c1.6 1.9 3.3 1.7 6.2-.6l4-3.3-5-6-4 3.3c-2.8 2.3-3.2 4.1-1.7 6z"></path>
                      <path fill="white" class="stroked" d="m173.8 259.7c2.1-.6 4.1 1.5 5.1 4.7l1.4 4.5c.6 2 1.8 3.3 4.5 2.5l6.8-2-4.1-13.8 14.9-4.5 11.1 37-25.6 7.7c-8.7 2.6-15.4-.3-17.2-6.1l-.3-.9c-1.1-3.6.8-7.7 5.2-10.2-5.7.9-9.1-1.9-10.3-5.8l-1.1-3.6c-.7-2.3-1.9-4.2-3.6-5.5l-.1-.2zm10.9 22.7c.7 2.4 2.4 2.9 5.9 1.9l5-1.5-2.2-7.5-5 1.5c-3.5 1-4.6 2.5-3.9 4.8z"></path>
                      <path fill="white" class="stroked" d="m158.5 263-4 38.5-38.2-3.9 1.1-10.7 22.7 2.4.6-5.4-15-1.6.6-5.5 15 1.6.5-5.2-22.7-2.4 1.2-11.6z"></path>
                      <path fill="white" class="stroked" d="m100 247.8c8.3 4.3 14 10.4 17.4 16.3l-8.7 4.7c-3.1-5-8.3-10.1-12.8-12.4-4.3-2.2-6.2-1.8-6.9-.5-2.3 4.3 22.6 14 16 26.4-3.2 6.2-13.6 7.3-24.2 1.8-8.2-4.3-12.1-9.2-15.6-15.1l8.8-4c3.1 4.7 7.3 8.8 11.5 10.9 3.4 1.8 5.5 1.6 6.1.4 2.5-4.7-22.8-14.4-16.5-26.4 3.7-6.9 14.6-7.5 24.9-2.1z"></path>
                      <path fill="white" class="stroked" d="m78.8 237-29.5 25-24.8-29.3 8.2-7 14.8 17.4 4.1-3.5-9.8-11.5 4.3-3.6 9.8 11.5 4-3.4-14.8-17.4 8.9-7.5z"></path>
                      <path fill="white" class="stroked" d="m42.8 176c.7 2-1.5 4.1-4.6 5.1l-4.5 1.4c-2 .6-3.3 1.9-2.4 4.6l2.2 6.7 13.7-4.4 4.8 14.8-36.8 11.9-8.2-25.3c-2.8-8.7 0-15.4 5.8-17.3l.9-.3c3.5-1.1 7.7.7 10.3 5-1-5.7 1.7-9.2 5.6-10.4l3.6-1.2c2.3-.7 4.2-2 5.4-3.7l.2-.1zm-22.5 11.4c-2.4.8-2.9 2.5-1.7 5.9l1.6 4.9 7.4-2.4-1.6-4.9c-1.1-3.5-2.6-4.5-4.9-3.8z"></path>
                      <path fill="white" class="stroked" d="m41.6 133.2-1.4 14.9-40.2 13.5 1.6-16.9 23.7-6.9-21.9-11.7 1.4-14.1z"></path>
                      <path fill="white" class="stroked" d="m55.7 94.2-6.7-.9-6.1 12.1 4.6 5.1-6.1 12.1-27.4-31.5 7.6-14.9 41.7 3.3zm-26.8-4 7.9 8.5 3.4-6.7z"></path>
                      <path fill="white" class="stroked" d="m87.1 60.2c-1.6 1.4-4.4.2-6.5-2.4l-3-3.6c-1.3-1.6-3-2.4-5.1-.5l-5.5 4.5 9.2 11.1-11.9 10-24.8-29.7 20.5-17.1c7-5.8 14.3-5.8 18.2-1.1l.6.7c2.4 2.8 2.3 7.4-.8 11.4 4.9-3.1 9.1-1.8 11.7 1.3l2.4 2.9c1.6 1.9 3.4 3.2 5.5 3.6l.1.1zm-18.9-16.6c-1.6-1.9-3.3-1.7-6.2.6l-4 3.3 5 6 4-3.3c2.8-2.3 3.2-4.1 1.7-5.9z"></path>
                    </svg>
                  </div>
                  <svg class="bar--one" viewBox="0 0 56 56">
                    <path d="M39.5,0h-1.3H17.7H0v16.5h26.8L0,43.2L12.8,56l13.7-13.7l13.1-13V56H56V38.3V17.7v-1.3V0H39.5z"></path>
                  </svg>
                  <svg class="bar--two" viewBox="0 0 56 56">
                    <path d="M39.5,0h-1.3H17.7H0v16.5h26.8L0,43.2L12.8,56l13.7-13.7l13.1-13V56H56V38.3V17.7v-1.3V0H39.5z"></path>
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
  </div>

</template>
  
<script>
import UserButton from './UserArea/HeaderButton.vue'
export default {
  name: 'DropdownMenu',
  components: {
    UserButton
  },
  props: {
    isOpenDropdown: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      color: '#ffff'
    }
  },
  methods: {
    closeDropdown(route) {
      this.$emit('isOpen', false)

      if (typeof route === 'string' && route !== '') {
        this.$router.push({ name: route })
      }

      setTimeout(() => {
        this.$emit('showIcon', false)
      }, 1000)
    }
  },
}
</script>

<style scoped lang="scss">

#dropdown-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #ee2737;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
  animation-duration: .64s;
}

.show-menu {
  animation: open .64s cubic-bezier(0.78, 0, 0.13, 1);
  animation-fill-mode: forwards;
  @keyframes open {
    from {
      transform: translateY(-100%);
    } to {
      transform: translateY(0%);
      animation-timing-function: .64s cubic-bezier(0.78, 0, 0.13, 1);
    }
  }
}

.close-menu {
  animation: close .64s cubic-bezier(0.78, 0, 0.13, 1);
  animation-fill-mode: forwards;
  @keyframes close {
    from {
      transform: translateY(0%);
    } to {
        transform: translateY(-100%);
        animation-timing-function: .64s cubic-bezier(0.78, 0, 0.13, 1);
      }
  }
}


.header-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
  width: 100%;

  .menu-button {
    background-color: #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 4rem;
    height: 4rem;
    cursor: pointer;
    position: relative;

    .line {
      width: 2rem;
      height: 0.2rem;
      border: 1px solid white;
      background-color: white;
      border-radius: 5px;
      transition: transform 6s;
      position: absolute;
    }
    
    .line:nth-child(1) {
      transform: rotate(45deg) translateY(-50%) scaleX(0);
      transform-origin: top left;
      top: 22px;
      left: 30%;
    }
    
    .line:nth-child(2) {
      transform: rotate(-45deg) translateY(50%) scaleX(0);
      transform-origin: bottom left;
      bottom: 19px;
      left: 30%;
    }

    .animate-1 {
      transition: transform 6s;
      animation: line 0.5s ease-in-out forwards  0.45s;
    }
    .animate-2 {
      transition: transform 6s;
      animation: lineTwo 0.5s ease-in-out forwards  0.45s;
    }
    
    @keyframes line {
      0% {
        transform: rotate(45deg) translateY(-50%) scaleX(0);
      }
      100% {
        transform: rotate(45deg) translateY(-50%) scaleX(1);
      }
    }
    @keyframes lineTwo {
      0% {
        transform: rotate(-45deg) translateY(50%) scaleX(0);
      }
      100% {
        transform: rotate(-45deg) translateY(50%) scaleX(1);
      }
    }
    
    @media only screen and (min-width: 768px) {
      width: 6rem;
      height: 6rem;

      .line {
        width: 4rem;
      }

      .line:nth-child(1) {
        top: 28px;
        left: 28%;
      }
      
      .line:nth-child(2) {
        bottom: 22px;
        left: 27%;
      }
    }

    @media only screen and (min-width: 1280px) {
      height: 7.5rem;
      width: 7.5rem;
      
      .line:nth-child(1) {
        top: 40px;
      }
      
      .line:nth-child(2) {
        bottom: 33px;
      }
    }

    @media only screen and (min-width: 1600px) {
      height: 9rem;
      width: 9rem;
      .line {
        width: 5rem;
      }

      .line:nth-child(1) {
        top: 45px;
      }
      
      .line:nth-child(2) {
        bottom: 41px;
      }
    }
  }

  .lang--switch {
    display: flex;
    gap: 20px;
    position: relative;

    .active {
      position: relative;
      z-index: 34;
      .lang--btn {
        background: #ee2737;
      }
    }

    .btn {
      border-radius: 32px;
      background-color: rgba(0,0,0,0);
      border-color: #fff;
      color: #fff;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      font-family: "Knockout";
      margin-bottom: -6px;
      text-transform: uppercase;
      min-width: 60px;
      padding: .8rem;

      .arrow-drop-down {
        margin: -0.4375rem -0.25rem;
        all: unset;
        order: 1;
        width: 1rem;
        transition: .4s;
      }

      .active {
        transform: rotate(180deg);
      }
      .icon--filled__glyph {
        fill: #fff;
        fill-rule: evenodd;
        stroke: none;
      }
    }

    .lang--btn {
      font-size: .75rem;
      gap: 0.25rem;
      padding: 0.5rem 0.625rem;
      border: 2px solid #fff;

      span {
        font-weight: 400;
        margin-right: 0;
        text-align: center;
        width: 100%;
      }
    }

    .langs--availables {
      display: flex;
      flex-direction: column;
      gap: 14px;
      overflow: hidden;

      .btn {
        border-radius: 32px;
        background-color: rgba(0,0,0,0);
        border-color: #fff;
        color: #fff;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        font-family: "Knockout";
        margin-bottom: -6px;
        text-transform: uppercase;
        padding: .8rem;
      }

      .lang--btn {
        background: transparent;
        border: 2px solid #fff;
        display: block;
        font-size: .75rem;
        gap: 0.25rem;
        margin-left: 0 !important;
        position: absolute;
        opacity: 0;
        top: 0;
        left: 0;
        transition: transform .4s cubic-bezier(0.78, 0, 0.13, 1),opacity 0s .4s;
        transform: translateY(0);
        text-align: center;
        pointer-events: none;
        padding: 0.4rem 0.625rem;
        width: 76%;
        z-index: 33;
      }

      a:hover {
        background-color: #fff;

        span {
          font-weight: 400;
          margin-right: 0;
          text-align: center;
          width: 100%;
          color: #000;
        }
      }
    }
  }
  .open {
    .langs--availables {
      .lang--btn {
        opacity: 1;
        pointer-events: auto;
        transition: transform .4s cubic-bezier(0.78, 0, 0.13, 1);
      }
      .lang--btn:first-child {
        transform: translateY(calc(100% + 0.5rem));
      }
      .lang--btn:nth-child(2) {
        transform: translateY(calc(200% + 1rem));
      }
      .lang--btn:nth-child(3) {
        transform: translateY(calc(300% + 1.5rem));
      }
      .lang--btn:nth-child(4) {
        transform: translateY(calc(400% + 1rem));
      }
    }
  }


  .close-dropdown {
    cursor: pointer;
    background-color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 4rem;
    width: 4rem;
    color: #fff;
  }
  .session-btn {
    padding: 0 10px;
  }

  @media only screen and (min-width: 768px) {
    .close-dropdown {
      height: 7.5rem;
      width: 7.5rem;
    }

    .lang--switch {
      .btn {
        padding: 0.8rem 1.6rem;
        min-width: 85px;
      }

      .lang--btn {
        font-weight: 400;
        padding: 0.45rem 1rem;
        border: 2px solid #fff;

        span {
          font-size: 1rem;
        }

        .arrow-drop-down, .arrow-drop-up {
          width: 2rem;
        }
      }

      .langs--availables {
        .lang--btn {
          width: calc(76% + .5rem) !important;
        }
      }
    }
  }

  @media only screen and (min-width: 1600px) {
    padding-right: 2.5rem;
    .lang--switch {
      gap: 20;
    }
  }
}

.options {
  display: flex;
  justify-content: flex-start;
  padding: 2rem 1.5rem;
  height: 93vh;
  width: 100%;

  .logo-rotate {
    display: none;
  }

  .animate-primary-menu {
    .nav-header-primary {
      & a, & span {
        opacity: 0;
        overflow: hidden;
        transform: scaleY(0);
        transition: transform 0.2s ease;
        animation: slideAndGrow 0.2s ease forwards 0.45s;
      }
    }
  }

  @keyframes slideAndGrow {
      0% {
        opacity: 0;
        transform: scaleY(0);
      }
      100% {
        opacity: 1;
        transform: scaleY(1);
      }
    }

  .section {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0;
    padding: 10px 5px;
    width: 100%;
    .options__main {
      display: flex;
      flex-direction: column;
      a {
        text-decoration: none;
      }
      span {
        cursor: pointer;
        color: #fff;
        font-size: 2rem;
        font-family: "Knockout";
        line-height: 1;
        text-transform: uppercase;
      }
      &--title:hover {
        color: transparent;
        -webkit-text-stroke: 2px #fff;
      }
    }

    


    &__body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 100px;
      height: 100%;
    }
    .options__footer {
      display: flex;
      flex-direction: column;

      &--1, &--2 {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        gap: 10px;
        line-height: 1.5rem;
        letter-spacing: -0.016em;
        color: #fff;
        width: 100%;
        position: relative;
      }

      .text-container {
        position: relative;
        display: inline-block;
        overflow: hidden;
        color: white;
      }

      .hover-text {
        display: inline-block;
        position: relative;
        transition: all 0.3s ease-in-out;
        font-family: "Knockout Light", serif;
        font-size: 1.125rem;
        text-transform: uppercase;
      }

      .hover-text::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 0.125rem;
        background-color: #fff;
        transition: width 0.3s ease-in-out;
        transform-origin: left;
      }

      .text-container:hover .hover-text::before {
        width: 100%;
      }

      &--1 {
        margin-bottom: 10px;
      }
    }

    ul.nav-header-primary,
    ul.nav-header-secondary {
      margin: 0;
      padding: 0;

      li {
        list-style: none;
      }
    }

    .header__footer {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .animate-social-network {
        opacity: 0;
        animation: social-networks 0.5s ease-in-out forwards 0.2s;
      }
      .social-media-container {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .social__link {
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: content-box;
          line-height: 0;
          padding: 0.4rem;
          position: relative;
          width: 1rem;
          height: 1rem;
          background-color: #fff;
          border-radius: 50%;
          border: 2px solid #fff;

          svg {
            fill: #ee2737;
            width: 18px;
            height: 18px;
          }
        }
        .social__link:hover {
          background-color: transparent;

          svg {
            fill: #fff;
          }
        }
      }


      .wheel-container {
        position: relative;
        cursor: pointer;
        .wheel-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #000;
          padding: 0.625rem;
          border-radius: 50%;
          animation: rotate 6.4s linear infinite;
          margin-bottom: -10px;
          svg {
            width: 9rem;
            height: 9rem;

            .filled {
              fill: #fff;
            }
            .stroked {
              fill: rgba(0,0,0,0);
              stroke: #fff;
              stroke-width: 0.125rem;
            }
          }
        }

        .bar--one, .bar--two {
          transition: transform .64s cubic-bezier(0.78, 0, 0.13, 1);
        }
        .bar--one {
          fill: #fff;
          height: 46px;
          transform: scale(1);
          transform-origin: bottom left;
          opacity: 1;
          position: absolute;
          bottom: 56px;
          right: 64px;
          width: 2.25rem;
        }
        .bar--two {
          fill: #fff;
          height: 46px;
          transform: scale(0);
          transform-origin: top right;
          opacity: 0;
          position: absolute;
          bottom: 56px;
          right: 64px;
          width: 2.25rem;
        }

        .desactive {
          transition: none;
        }
      }

      .wheel-container:hover {
        .wheel-wrapper {
          background-color: #fff;
          svg {
            width: 9rem;
            height: 9rem;

            .filled {
              fill: rgba(0,0,0,0);
              stroke: #ee2737;
              stroke-width: 0.125rem;
            }
            .stroked {
              fill: #ee2737;
            }
          }
        }
        .bar--one {
          fill: #ee2737;
          transform-origin: top right;
          transform: scale(0);
          opacity: 1;
        }

        .bar--two {
          fill: #ee2737;
          transform-origin: bottom left;
          transform: scale(1);
          opacity: 1;
        }
      }

      @keyframes social-networks {
        0% {
          opacity: 0;
          transform: scale(0);
        }
        100% {
          opacity: 1;
          transform: scale(1);
        }
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  @media only screen and (min-width: 768px) {
    position: relative;
    padding-left: 90px;

    .section {
      gap: 60px;

      .options__main {
        span {
          font-size: 4.5rem;
        }
      }

      &__body {
        gap: 40px;
        justify-content: flex-end;
        margin-bottom: 10px;

        .header__footer {

          .social-media-container {
            flex-direction: row;
          }
        }
      }
      .options__footer {
        display: flex;
        flex-direction: column;

        &--1, &--2 {
          font-size: 1.4rem;
          line-height: 1.5rem;
        }
      }
    }
    .logo-rotate {
      cursor: pointer;
      display: block;
      fill: #fff;
      rotate: -90deg;
      position: absolute;
      top: 78px;
      left: 0;
      width: 6rem;
    }
    .animate-logo-rotate {
      opacity: 0;
      animation: slideInFromTop 0.3s ease forwards 0.45s;
    }

    @keyframes slideInFromTop {
      0% {
        transform: translateX(30%);
      }
      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .header__footer {
      .wheel-container {
        position: relative;
        .wheel-wrapper {
          position: absolute;
          right: 30px;
          bottom: 20px;
          padding: 1rem !important;
          margin-right: -10px;
          margin-bottom: -40px !important;

          svg {
            width: 13rem !important;
            height: 13rem !important;
          }
        }

        .bar--one {
          height: 3.5rem !important;
          width: 3.5rem !important;
          bottom: 70px !important;
          right: 112px !important;
        }

        .bar--two {
          height: 3.5rem !important;
          width: 3.5rem !important;
          bottom: 70px !important;
          right: 112px !important;
        }
      }
    }
  }

  @media only screen and (min-width: 1280px) {
    padding-left: 100px;
    .section {
      padding-left: 20px;
      .options__main {
        span {
          font-size: 6rem;
        }
      }

      .options__footer {
        flex-direction: row;
        gap: 30px;
        line-height: normal;

        &--1, &--2 {
          font-size: 28px;
          line-height: 1;
          /*max-width: 300px;*/
        }

        .hover-text {
          font-size: 1.5rem;
          line-height: 1.75rem;
          letter-spacing: -0.016em;
        }
      }
    }

    .logo-rotate {
      width: 7.5rem;
      top: 80px;
    }

    .header__footer {
      .wheel-container {
        position: relative;
        .wheel-wrapper {
          right: 20px !important;
          bottom: 25px !important;
        }

        .bar--one {
          bottom: 79px !important;
          right: 102px !important;
        }

        .bar--two {
          bottom: 79px !important;
          right: 102px !important;
        }
      }
    }
  }

  @media only screen and (min-width: 1600px) {
    .section {
      padding-left: 46px;
      .options__main {
        span {
          font-size: 7.5rem;
        }
      }
    }

    .logo-rotate {
      width: 9rem;
      top: 103px;
    }

    .options__footer {
      .hover-text {
        font-size: 1.75rem;
      }
    }
    

    .header__footer {
      .wheel-container {
        .wheel-wrapper {
          padding: 1.3rem !important;
          right: 40px !important;
          bottom: 40px !important;

          svg {
            width: 17.5rem !important;
            height: 17.5rem !important;
          }
        }

        .bar--one {
          height: 4.5rem !important;
          width: 4.5rem !important;
          bottom: 126px !important;
          right: 158px !important;
        }

        .bar--two {
          height: 4.5rem !important;
          width: 4.5rem !important;
          bottom: 126px !important;
          right: 158px !important;
        }
      }
    }
  }
}

.hidden-dropdown, .hidden {
  display: none !important;
}

.pac-container{
  position: absolute;
  bottom: 172px;
  width: 308px !important;
  top: auto !important;
}

@media only screen and (min-width: 410px) {
  .pac-container{
    width: 362px !important;
  }
}

@media only screen and (min-width: 480px) {
  .pac-container{
    width: 450px !important;
    bottom: 225px !important;
  }
}

@media only screen and (min-width: 768px) {
  .pac-container{
    bottom: 130px !important;
    width: 400px !important;
  }
}

@media only screen and (min-width: 1024px) {
  .pac-container{
    bottom: 110px !important;
    left: 290px !important;
  }
}

@media only screen and (min-width: 1100px) {
  .pac-container{
    bottom: 110px !important;
    width: 300px !important;
  }
}

@media only screen and (min-width: 1440px) {
  .pac-container{
    bottom: 110px !important;
    width: 400px !important;
  }
}


</style>
